import { FC } from "react"
import { KAMsRBDsFAMsPropsType, KAMsListObjectType, RBDsListObjectType, FAMsListObjectType } from "./types";
import RBDs from "../RBDs";
import KAMs from "../KAMs";
import FAMs from "../FAMs";

const KAMsRBDsFAMs: FC<KAMsRBDsFAMsPropsType> = ({ KAMsListType, FAMsListType, RBDsListType, defaultQueryParams, updateQueryParams }): JSX.Element => {

  return (
    <div className="row gx-3">
      <div className="col-12 col-lg-4 mt-3 overflow-auto">
        <KAMs data={KAMsListType?.data as unknown as KAMsListObjectType[]}
          ecr_total={KAMsListType?.ecr_total}
          case_total={KAMsListType?.case_total}
          defaultQueryParams={defaultQueryParams}
          updateQueryParams={updateQueryParams}
        />
      </div>
      <div className="col-12 col-lg-4 mt-3 overflow-auto">
        <RBDs data={RBDsListType?.data as unknown as RBDsListObjectType[]}
          ecr_total={RBDsListType?.ecr_total}
          case_total={RBDsListType?.case_total}
          defaultQueryParams={defaultQueryParams}
          updateQueryParams={updateQueryParams} />
      </div>
      <div className="col-12 col-lg-4 mt-3 overflow-auto">
        <FAMs data={FAMsListType?.data as unknown as FAMsListObjectType[]}
          ecr_total={FAMsListType?.ecr_total}
          case_total={FAMsListType?.case_total}
          defaultQueryParams={defaultQueryParams}
          updateQueryParams={updateQueryParams} />
      </div>
    </div>
  );
};

export default KAMsRBDsFAMs;
